import http from 'hub-http/clients/apiClient';
import { registerMutation, useMutation } from 'academy-common-lib/utils/DataFetchingClient';
import { BASE_URI_PROGRESS } from '../../../../../constants/uri';
const PROGRESS_TRANSFER_API_URL = `${BASE_URI_PROGRESS}/user-swaps`;
const SEND_PROGRESS_TRANSFER_REQUEST = registerMutation({
  fieldName: 'sendProgressTransferRequest',
  args: ['newUserEmail'],
  fetcher({
    newUserEmail
  }) {
    return http.post(`${PROGRESS_TRANSFER_API_URL}/swap-by-email`, {
      data: {
        newUserEmail
      }
    });
  }
});
const VERIFY_PROGRESS_TRANSFER_REQUEST = registerMutation({
  fieldName: 'verifyProgressTransferRequest',
  args: ['confirmationGuid'],
  fetcher({
    confirmationGuid
  }) {
    return http.post(`${PROGRESS_TRANSFER_API_URL}/confirm-request`, {
      timeout: 14000,
      data: {
        confirmationGuid
      }
    });
  }
});
export const useSendProgressTransferRequest = () => {
  return useMutation(SEND_PROGRESS_TRANSFER_REQUEST);
};
export const useVerifyProgressTransferRequest = () => {
  return useMutation(VERIFY_PROGRESS_TRANSFER_REQUEST);
};